export default "__VITE_ASSET__BQSCSfXY__"